

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./BottomNavVolatility.css";

const BottomNavVolatility = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "History", path: "/volatility-history", icon: "history" },
    { label: "Market", path: "/market", icon: "market" },
    { label: "Closed", path: "/volatility-closed", icon: "closed" },
    { label: "Open", path: "/volatility-open", icon: "open" },
    { label: "Transaction", path: "/transactions", icon: "transaction" },
  ];
  
  const isActive = (path) => {
    if (path === "/history") {
      return (
        location.pathname === "/history" ||
        location.pathname === "/"
      );
    }

    return location.pathname === path;
  };

  return (
    <nav
      className="bottom-nav-volatility"
      aria-label="Volatility navigation"
    >
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`bottom-nav-volatility-item ${
            isActive(tab.path) ? "active" : ""
          }`}
          onClick={() => navigate(tab.path)}
          aria-label={tab.label}
          aria-current={isActive(tab.path) ? "page" : undefined}
        >
          <span
            className={`bottom-nav-volatility-icon ${tab.icon}-icon`}
          >
            {tab.icon === "history" && (
              <>
                <span className="history-icon-line line-one" />
                <span className="history-icon-line line-two" />
                <span className="history-icon-line line-three" />
              </>
            )}

            {tab.icon === "market" && (
              <>
                <span className="market-icon-candle candle-one" />
                <span className="market-icon-candle candle-two" />
                <span className="market-icon-candle candle-three" />
                <span className="market-icon-candle candle-four" />
              </>
            )}

            {tab.icon === "closed" && (
              <span className="closed-icon-circle">
                <span className="closed-icon-check" />
              </span>
            )}

            {tab.icon === "open" && (
              <span className="open-icon-ring">
                <span className="open-icon-dot" />
              </span>
            )}

            {tab.icon === "transaction" && (
              <>
                <span className="transaction-icon-row row-one" />
                <span className="transaction-icon-row row-two" />
                <span className="transaction-icon-row row-three" />
              </>
            )}
          </span>

          <span className="bottom-nav-volatility-label">
            {tab.label}
          </span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNavVolatility;
